import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-accb5ef8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-md-8" }
const _hoisted_2 = {
  id: "expert-booking-container",
  class: "col-md-4"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex align-items-center mb-1"
}
const _hoisted_7 = {
  key: 1,
  class: "d-flex align-items-center mb-1"
}
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "text-bold ml-1 text-preline" }
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = { class: "mb-1" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "p-button-label" }
const _hoisted_16 = {
  key: 1,
  class: "my-2"
}
const _hoisted_17 = { class: "text-warning" }
const _hoisted_18 = { class: "ml-2" }
const _hoisted_19 = { class: "text-warning" }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { class: "mx-1" }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = { class: "d-flex flex-row align-items-center justify-content-start my-2" }
const _hoisted_24 = { class: "leading mb-0 ml-1" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "popover-icon pi pi-question" }, null, -1))
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "text-preline" }
const _hoisted_28 = ["href"]
const _hoisted_29 = {
  key: 0,
  class: "d-flex justify-content-end"
}
const _hoisted_30 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExpertProfile = _resolveComponent("ExpertProfile")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_ExpertBookingCalendar = _resolveComponent("ExpertBookingCalendar")!
  const _component_ExpertBookingSlider = _resolveComponent("ExpertBookingSlider")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_PopoverIcon = _resolveComponent("PopoverIcon")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_PriceSummary = _resolveComponent("PriceSummary")!
  const _component_WalletMessage = _resolveComponent("WalletMessage")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ExpertBookingModal = _resolveComponent("ExpertBookingModal")!
  const _component_ProductAddedModal = _resolveComponent("ProductAddedModal")!
  const _component_StickyScrollToButton = _resolveComponent("StickyScrollToButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ExpertProfile, {
        "expert-product": _ctx.vm?.expertProduct,
        "expert-profile": _ctx.vm?.expertProfile
      }, null, 8, ["expert-product", "expert-profile"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Card, {
        class: _normalizeClass(["expert-booking-card", { 'position-static': _ctx.isLargeScreen }])
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(`${_ctx.$t("expert.titleBookingCard", [_ctx.bookingSummary?.expertDetails?.firstName])}`), 1)
        ]),
        subtitle: _withCtx(() => [
          _createElementVNode("b", null, _toDisplayString(_ctx.formatCurrency(_ctx.bookingSummary?.expertDetails?.hourlyRate || 0)), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("expert.hourExclTax")), 1)
        ]),
        content: _withCtx(() => [
          (_ctx.canBookExpert)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _createElementVNode("h5", null, _toDisplayString(_ctx.$t(`expert.workRemoteOrOnLocation`)), 1),
                  _createVNode(_component_SelectButton, {
                    modelValue: _ctx.selectedLocationOption,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedLocationOption) = $event)),
                    class: "d-flex",
                    "option-label": "label",
                    options: _ctx.locationOptions,
                    unselectable: false
                  }, null, 8, ["modelValue", "options"])
                ]),
                (!_ctx.isRemote)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("h5", null, _toDisplayString(_ctx.$t(`expert.workLocation`)), 1)
                      ]),
                      (_ctx.editWorkLocation)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_GMapAutocomplete, {
                              class: "w-100",
                              placeholder: _ctx.$t(`expert.searchYourLocation`),
                              onChange: _ctx.onLocationSelected,
                              onPlace_changed: _ctx.onPlaceChanged
                            }, null, 8, ["placeholder", "onChange", "onPlace_changed"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("i", {
                              class: "pi pi-map-marker text-primary",
                              title: _ctx.$t('cart.table.iconLocation_title')
                            }, null, 8, _hoisted_8),
                            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.bookingSummary.configuration.workLocation.name), 1),
                            _createVNode(_component_Button, {
                              class: "p-button-text ml-auto",
                              icon: "pi pi-pencil",
                              label: _ctx.isSmallScreen ? _ctx.$t('common.edit') : '',
                              title: _ctx.$t('common.edit'),
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editWorkLocation = true))
                            }, null, 8, ["label", "title"])
                          ]))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h5", _hoisted_11, _toDisplayString(` ${_ctx.$t("expert.whenDoYouWantToBook", [_ctx.bookingSummary?.expertDetails?.firstName])}`), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedDates, (selected, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: JSON.stringify(selected),
                      class: "d-flex flex-row align-items-center mb-1"
                    }, [
                      _createVNode(_component_Chip, {
                        class: _normalizeClass(["custom-chip", {
									'surface-e': index === _ctx.editDateIndex,
									'p-disabled': _ctx.editDateIndex != null && index !== _ctx.editDateIndex,
								}]),
                        label: `${_ctx.formatDate(selected.date)} ${_ctx.formatTime(selected.start)} - ${_ctx.formatTime(selected.end)}`,
                        removable: "",
                        onClick: _withModifiers(($event: any) => (_ctx.openDate(selected, index)), ["stop"]),
                        onRemove: _withModifiers(($event: any) => (_ctx.deleteDate(index, selected)), ["stop"])
                      }, null, 8, ["class", "label", "onClick", "onRemove"])
                    ]))
                  }), 128)),
                  (_ctx.visibleStep === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (_ctx.selectedDates?.length)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              class: "p-button-secondary p-button-text mb-2 mt-1 px-0",
                              icon: "pi pi-calendar-plus p-button-icon-lg",
                              label: _ctx.$t(`expert.button.addAnotherDate`),
                              onClick: _cache[2] || (_cache[2] = () => (_ctx.visibleStep = 2))
                            }, null, 8, ["label"]))
                          : (_openBlock(), _createBlock(_component_Button, {
                              key: 1,
                              class: "w-100 mb-2",
                              label: _ctx.$t(`expert.button.chooseDate`),
                              onClick: _cache[3] || (_cache[3] = () => (_ctx.visibleStep = 2))
                            }, null, 8, ["label"]))
                      ]))
                    : (_ctx.visibleStep === 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(_component_ExpertBookingCalendar, {
                            modelValue: _ctx.selectedDate,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedDate) = $event)),
                            "availability-dates": _ctx.bookingSummary?.availabilityDates,
                            "calendar-max-date": _ctx.bookingSummary?.calendarMaxDate,
                            "calendar-min-date": _ctx.bookingSummary?.calendarMinDate,
                            "selected-date-starting-hour": _ctx.selectedDateStartingHour,
                            "selected-dates": _ctx.selectedDates,
                            "selected-location-option": _ctx.selectedLocationOption,
                            "total-work-hours": _ctx.totalWorkHours,
                            onDateSelect: _ctx.onDateSelected
                          }, null, 8, ["modelValue", "availability-dates", "calendar-max-date", "calendar-min-date", "selected-date-starting-hour", "selected-dates", "selected-location-option", "total-work-hours", "onDateSelect"])
                        ]))
                      : (_ctx.visibleStep === 3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createVNode(_component_Button, {
                              class: "p-button-outlined w-100 mb-2",
                              label: _ctx.formatDate(_ctx.selectedDate),
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.visibleStep = 2))
                            }, null, 8, ["label"]),
                            _createVNode(_component_SelectButton, {
                              modelValue: _ctx.selectedDayParts,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedDayParts) = $event)),
                              class: "d-flex day-part-select",
                              "option-disabled": "isDisabled",
                              "option-label": "label",
                              options: _ctx.dayParts,
                              unselectable: false,
                              onChange: _ctx.resetSelectedHours
                            }, {
                              option: _withCtx((slotProps) => [
                                _createElementVNode("span", _hoisted_15, _toDisplayString(slotProps.option.label) + _toDisplayString(slotProps.option.isDisabled ? "*" : ""), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "options", "onChange"]),
                            (_ctx.selectedDayParts?.value === _ctx.ExpertBookingDateType.morning)
                              ? (_openBlock(), _createBlock(_component_SelectButton, {
                                  key: 0,
                                  modelValue: _ctx.selectedDayPartsTimes,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedDayPartsTimes) = $event)),
                                  class: "mt-2 d-flex",
                                  "option-disabled": "isDisabled",
                                  "option-label": "label",
                                  options: _ctx.dayPartsTimes,
                                  unselectable: false
                                }, null, 8, ["modelValue", "options"]))
                              : _createCommentVNode("", true),
                            (_ctx.concatenatedUnavailableHours.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _createElementVNode("small", _hoisted_17, _toDisplayString(_ctx.$t("expert.lblExpertNotAvailableBetween")), 1),
                                  _createElementVNode("ul", _hoisted_18, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.concatenatedUnavailableHours, (unavailableHour, index) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: `unavailable-hour-${index}`
                                      }, [
                                        _createElementVNode("small", _hoisted_19, " - " + _toDisplayString(_ctx.formatTime(unavailableHour.start.time)) + " - " + _toDisplayString(_ctx.formatTime(unavailableHour.end.time)), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.selectedDayParts?.value === _ctx.ExpertBookingDateType.hour)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createVNode(_component_ExpertBookingSlider, {
                                      modelValue: _ctx.selectedHours,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedHours) = $event)),
                                      "selected-date": _ctx.selectedDate,
                                      "unavailable-hours": _ctx.concatenatedUnavailableHours,
                                      "work-day-end-hour": _ctx.workDayEndHour,
                                      "work-day-start-hour": _ctx.workDayStartHour,
                                      onOnValidityChange: _ctx.onValidityChange
                                    }, null, 8, ["modelValue", "selected-date", "unavailable-hours", "work-day-end-hour", "work-day-start-hour", "onOnValidityChange"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                  (_ctx.visibleStep === 1 && _ctx.selectedDates.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_InputSwitch, {
                            modelValue: _ctx.isFlexBooking,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isFlexBooking) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t(`enum.expertCalculationLineType.5`, [
											_ctx.vm.bookingSummary.expertDetails.flexBookingPercentage,
										])), 1),
                          _createVNode(_component_PopoverIcon, { class: "d-inline-flex ml-0" }, {
                            content: _withCtx(() => [
                              _createElementVNode("div", {
                                innerHTML: 
												_ctx.$t(`expert.withFlexBookingYouCanCancelYourBookingFor`, [
													_ctx.$tc(
														'common.days',
														_ctx.bookingSummary?.expertDetails?.flexBookingCancellationTerm
													),
												])
											
                              }, null, 8, _hoisted_26)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_25
                            ]),
                            _: 1
                          })
                        ]),
                        (_ctx.isSpinnerVisible('priceSummary'))
                          ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
                              key: 0,
                              "animation-duration": ".75s",
                              class: "d-flex justify-content-center mt-3 mb-3",
                              "stroke-width": "3"
                            }))
                          : (_openBlock(), _createBlock(_component_PriceSummary, {
                              key: 1,
                              vm: _ctx.priceSummary
                            }, null, 8, ["vm"])),
                        _withDirectives(_createVNode(_component_WalletMessage, {
                          "wallet-amount": _ctx.expertPriceCalculation?.walletAmount || 0
                        }, null, 8, ["wallet-amount"]), [
                          [_vShow, _ctx.vm?.bookingSummary.canUseWallet]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createBlock(_component_Message, {
                key: 1,
                closable: false,
                severity: "warn"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_27, [
                    _createVNode(_component_i18n_t, { keypath: "expert.message.expertNotAvailable" }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          href: `tel:${_ctx.$t('common.support.phoneNumber')}`
                        }, _toDisplayString(_ctx.$t("common.support.phoneNumber")), 9, _hoisted_28)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }))
        ]),
        footer: _withCtx(() => [
          (_ctx.visibleStep !== 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createVNode(_component_Button, {
                  class: "p-button-secondary p-button-text mr-2",
                  label: _ctx.$t('common.cancel'),
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.cancelBooking()))
                }, null, 8, ["label"]),
                _createVNode(_component_Button, {
                  class: "p-button-primary",
                  disabled: !_ctx.canAddDate,
                  label: _ctx.isEditingDate ? _ctx.$t(`expert.button.editDate`) : _ctx.$t(`expert.button.addDate`),
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onDateAdded()))
                }, null, 8, ["disabled", "label"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createVNode(_component_Button, {
                  class: "p-button-success p-button-raised p-button-arrow w-100 px-1 mb-1",
                  disabled: !_ctx.canSubmit,
                  label: 
							_ctx.isRequestBooking ? _ctx.$t(`expert.button.sendRequest`) : _ctx.$t(`expert.button.confirmBooking`)
						,
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openBookingModal()))
                }, null, 8, ["disabled", "label"])
              ]))
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    (_ctx.expertStore.isBookingRequestModalVisible)
      ? (_openBlock(), _createBlock(_component_ExpertBookingModal, {
          key: 0,
          "booking-summary": _ctx.bookingSummary,
          "modal-type": _ctx.modalType,
          onSubmit: _ctx.onModalSubmit
        }, null, 8, ["booking-summary", "modal-type", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.cartStore.showProductAddedModal)
      ? (_openBlock(), _createBlock(_component_ProductAddedModal, {
          key: 1,
          vm: _ctx.productAddedModel
        }, null, 8, ["vm"]))
      : _createCommentVNode("", true),
    (_ctx.isMediumScreen)
      ? (_openBlock(), _createBlock(_component_StickyScrollToButton, {
          key: 2,
          "button-label": _ctx.$t(`expert.button.bookNow`),
          offset: 80,
          "parent-container-id": "expert-booking-container",
          target: ".expert-booking-card"
        }, null, 8, ["button-label"]))
      : _createCommentVNode("", true)
  ], 64))
}